import React from "react";

const Positions = () => {
  return <div>Positions</div>;
};

export default Positions;
